import stylex from '@stylexjs/stylex';
import { colors } from '@shared/tokens/colors.stylex';

export const scrollbarStyles = stylex.create({
  host: {
    position: 'relative',
    width: '871px',
    height: '100%',
  },
  scroll: {
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    boxSizing: 'border-box',
    width: '100%',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '::-webkit-scrollbar': {
      width: 0,
      height: 0,
    },
  },
  track: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: '4px',
    height: '100%',
    borderRadius: '4px',
    backgroundColor: colors.ghostBackground,
  },
  thumb: {
    position: 'absolute',
    left: 0,
    width: '100%',
    borderRadius: '4px',
    backgroundColor: colors.accentBackground,
  },
});
